// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__3y-zQ","path":"style_path__3R-eT","arrow":"style_arrow__2O19U"};